import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Btn, Modal } from '../admin-kit';

/**
 * De vraag vóór iets dat niet terug te draaien is, in de vorm van het beheerportaal (BHR-3).
 *
 * Dezelfde afspraken als `ConfirmDialog` uit `@up2d8/ui`, dat hier stond: een titel, één zin over
 * wat er gebeurt, en een rode knop met het werkwoord. `testId` staat op die knop, zodat de
 * end-to-endtests niet veranderen.
 */
export function ConfirmModal({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  busy,
  testId,
  onConfirm,
}: {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  description: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  testId?: string;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Btn variant="sec" onClick={onClose}>
            {t('common.cancel')}
          </Btn>
          <Btn variant="danger" testId={testId} disabled={busy} onClick={onConfirm}>
            {confirmLabel}
          </Btn>
        </>
      }
    >
      <p>{description}</p>
    </Modal>
  );
}
